module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/mobile-bottom-img.a47fe0f2.png";